import { useEffect, useState } from 'react';
import type { CategoriesResponse } from '../types';
import { fetchCategories } from '../lib/api';
import { normalizeSlashDate } from '../lib/dates';

interface State {
  loading: boolean;
  error: string | null;
  data: CategoriesResponse | null;
  /** Holiday set, ISO formatted (YYYY-MM-DD) for fast lookup */
  holidaySet: Set<string>;
}

export function useCategories(): State {
  const [state, setState] = useState<State>({
    loading: true,
    error: null,
    data: null,
    holidaySet: new Set(),
  });

  useEffect(() => {
    let cancelled = false;
    fetchCategories()
      .then(data => {
        if (cancelled) return;
        const holidaySet = new Set<string>();
        for (const h of data.holidays) {
          const iso = normalizeSlashDate(h);
          if (iso) holidaySet.add(iso);
        }
        setState({ loading: false, error: null, data, holidaySet });
      })
      .catch(err => {
        if (cancelled) return;
        setState(s => ({ ...s, loading: false, error: String(err) }));
      });
    return () => { cancelled = true; };
  }, []);

  return state;
}
